<template>
    <inline-svg 
        :src="`/src/assets/${name}.svg`"
        :aria-label="ariaLabel"
        class="svg-icon"
    />
</template>

<script>
    import InlineSvg from 'vue-inline-svg';
  
    export default {
        name: "SvgIcon",

        components: {
            InlineSvg,
        },

        props: {
            name: {
                type: String,
                required: true
            },
            ariaLabel: {
                type: String,
                required: false
            }
        }
    }
</script>